const ToastContainer = ({ toasts, onRemove }) => {
  if (!toasts || toasts.length === 0) return null;
  return (
    <div style={{ position: 'fixed', top: '80px', right: '20px', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '400px' }}>
      {toasts.map(t => (
        <div key={t.id} onClick={() => onRemove(t.id)} style={{
          padding: '0.85rem 1.25rem',
          background: t.type === 'error' ? 'rgba(239,68,68,0.95)' : t.type === 'warning' ? 'rgba(245,158,11,0.95)' : 'rgba(16,185,129,0.95)',
          color: 'white',
          borderRadius: '10px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontSize: '0.9rem',
          fontWeight: 500,
          animation: 'slideInRight 0.3s ease',
          backdropFilter: 'blur(10px)',
        }}>
          <span>{t.type === 'error' ? '❌' : t.type === 'warning' ? '⚠️' : '✅'}</span>
          <span style={{ flex: 1 }}>{t.message}</span>
          <span style={{ opacity: 0.7, fontSize: '1.1rem', lineHeight: 1 }}>×</span>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
